<template>
  <div class="right">
    <div class="bgc r_box_1">
      <div class="box_title title">{{rightBox.boxTitle}}</div>
      <div class="box_nr">
        <div class="box_txt">
          <div>
            <el-popover placement="left"
                        title="简介内容"
                        width="250"
                        trigger="hover"
                        :content="this.rightBox.boxText">
              <span slot="reference">{{rightBox.boxText}}</span>
            </el-popover>
          </div>
        </div>
        <div style="flex: 1;margin: 1%; background-color: #fff;position: relative;">
          <el-carousel height="100%"
                       v-if="rightBox.images.length>0"
                       indicator-position="none">
            <el-carousel-item v-for="(item,index) in rightBox.images"
                              :key="index">
              <el-image style="width:100%; height:100%;"
                        :src="item"
                        fit="fit"></el-image>
            </el-carousel-item>
          </el-carousel>
          <span style="position: absolute;
          left: 50%;
          top: 50%;transform: translate(-50%, -50%);"
                v-if="rightBox.images.length==0">暂无调研图片</span>
        </div>
      </div>
    </div>
    <div class="r_box_2 bgc">
      <el-table :data="regionList"
                @cell-click="handle"
                height="100%"
                :span-method="cellMerge"
                table-layout='auto'
                border>
        <el-table-column prop="region"
                         label="市"
                         width="80%">
        </el-table-column>
        <el-table-column prop="region_burg"
                         label="乡、村">
          <template scope="scope">
            <div @click="biao(scope.row)">{{ scope.row.region_burg }}</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>

</template>

<script>
import bus from '../utils/bus.js'

export default {
  props: {
    rightBox: {}
  },
  data () {
    return {
      regionList: [],
      spanArr: [],
      pos: '',
      region: ''
    }
  },
  mounted () {
    this.getRegionList()
  },
  methods: {
    // 获取表格数据
    getRegionList () {
      this.data = JSON.parse(localStorage.getItem("date"))
      // console.log(this.data);
      this.data.forEach((item, index1) => {
        item.slist.forEach((item2, index2) => {
          this.regionList.push({
            region: item.region,
            region_burg: item2.region_burg,
            ...item2
          }
          )
        })
      });
      // console.log(this.regionList);
      bus.$emit('regionList', this.regionList)

      //清空合并坐标
      this.spanArr = []
      this.pos = 0

      this.getSpanArr(this.regionList);
    },

    // 合并单元格
    getSpanArr (data) {
      for (var i = 0; i < data.length; i++)
      {
        if (i === 0)
        {
          this.spanArr.push(1);
          this.pos = 0
        } else
        {
          // 判断当前元素与上一个元素是否相同
          if (data[i].region === data[i - 1].region)
          {
            this.spanArr[this.pos] += 1;
            this.spanArr.push(0);
          } else
          {
            this.spanArr.push(1);
            this.pos = i;
          }
        }
      }
    },
    cellMerge ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0)
      {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col
        }
      }
    },


    handle (row, column, event, cell) {
      this.region = row.region
      bus.$emit('mapBus', row)
      this.$emit('region', this.region)
      console.log(row, column, event, cell)
      // console.log(event)
      // console.log(cell)
    },

    biao (data) {
      this.$bus.$emit('biaoData', data)
    }

  }
}
</script>

<style lang="less" scoped>
.right {
  position: absolute;
  top: 6vh;
  right: 0;
  margin: 0.5%;
  width: 25%;
  z-index: 10;

  .r_box_1 {
    width: 100%;
    height: 18vh;
    margin-bottom: 1vh;

    .box_title {
      padding: 1%;
      text-align: center;
      font-weight: 700;
    }

    .box_nr {
      display: flex;
      height: 13.5vh;

      div {
        height: 100%;
        // background-color: rgb(230, 230, 230);
      }

      .box_txt {
        flex: 1;
        margin: 1%;

        overflow: hidden;
        text-overflow: ellipsis;

        div {
          padding: 5px;
          text-align: justify;
          text-justify: inter-ideograph;

          span {
            font-size: calc(100vw * 12 / 1920);
          }
        }
      }
    }
  }

  .r_box_2 {
    width: 100%;
    height: 68vh;

    /deep/ .el-table {
      padding: 0;
      font-size: calc(100vw * 12 / 1920);
      cursor: pointer;
    }

    /deep/ .el-table th {
      font-size: calc(100vw * 16 / 1920);
      font-weight: 700;
      background-color: #ccffff;
    }

    /deep/ .el-table tr,
    .el-table {
      background-color: rgba(255, 255, 255, 0);
    }

    /deep/ .el-table__cell {
      padding: 2px 0;
      text-align: center;
    }
  }
}

/deep/ .nr {
  table.gridtable {
    // margin: 0 auto;
    // width: fit-content;
    width: 100%;
    font-family: verdana, arial, sans-serif;
    color: #333333;
    border-width: 1px;
    border-color: #666666;
    border-collapse: collapse;
    text-align: center;

    .title_th {
      width: 10%;
    }

    .nr_th {
      width: 10%;
    }

    .table_img {
      column-count: 3; //想要排成的列数
      // column-gap: 0.5vh;
      img {
        width: 80%;
        margin: 1%;
      }
    }
  }
  table.gridtable th {
    font-weight: 900;
    border-width: 1px;
    padding: 8px;
    border-style: solid;
    border-color: #666666;
    background-color: #dedede;
    text-align: center;
  }
  table.gridtable td {
    border-width: 1px;
    padding: 8px;
    border-style: solid;
    border-color: #666666;
    background-color: #ffffff;
    height: 4vh;
  }
}

/deep/ .el-radio {
  margin-right: 1vh;
}
</style>